import { NgFilter } from "@app/di/decorators";
import { Token } from "@app/di/token";

@NgFilter({
    token: Token.BytesFilter,
    dependencies: [
    ]
})
export class BytesFilter {
    constructor() {
        return ((bytes, precision) => {
            if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) return "-";
            if (bytes == 0) return "0 KB";            
            let units = ["bytes", "KB", "MB", "GB", "TB", "PB"];
            let n = Math.floor(Math.log(bytes) / Math.log(1024));
            if (typeof precision === "undefined") precision = (n? 1: 0);
            return (bytes / Math.pow(1024, Math.floor(n))).toFixed(precision) + " " + units[n];
        }) as any;
    }

}
